/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".limit-width.center.subform-card.mat-card.ng-star-inserted[_ngcontent-%COMP%]{margin-top:0;margin-bottom:20px;padding:16px;min-width:280px}.done[_ngcontent-%COMP%]:not(.allow-multiple){text-decoration:line-through}.form-completion-number[_ngcontent-%COMP%]{position:relative;font-weight:400;margin-right:5px}.mat-done-icon[_ngcontent-%COMP%]{position:absolute;left:-12px;top:10px}.mat-list-item-content[_ngcontent-%COMP%]{padding:0 0 0 16px!important}\n/*# sourceMappingURL=subform-select.component.css.map*/"];
export { styles as styles };
